import React from "react"
// import { featuredList } from "services/constants"
import { Container, Typography } from "@material-ui/core"
import { AppStyles } from "assets/styles/App"
import ReposPost from "components/ReposPost"
import { useStaticQuery, graphql } from "gatsby"

interface Props {}

interface Repos {
  id: string
  nameWithOwner: string
  createdAt: string
  description: string
  isPrivate: boolean
  url: string
  language: object
  homepageUrl: string
}

const AboutMe: React.FC<Props> = () => {
  const classes = AppStyles()
  const data = useStaticQuery(graphql`
    query {
      github {
        user(login: "warifmust") {
          repositories(first: 20) {
            nodes {
              id
              nameWithOwner
              createdAt
              description
              isPrivate
              url
              homepageUrl
              languages(first: 5) {
                nodes {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  `)

  const repos = data.github.user.repositories.nodes

  return (
    <div className={classes.featuredOuter}>
      <Container maxWidth="md">
        <Typography
          className={classes.heroTitle}
          variant="h2"
          align="center"
          color="textPrimary"
          gutterBottom
        >
          My Shared Projects<span role="img">💻</span>
        </Typography>
        <Container
          maxWidth="lg"
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          {repos
            .filter((r: Repos) => r.isPrivate !== true)
            .map((r: Repos) => {
              return <ReposPost key={r.id} post={r} />
            })}
        </Container>
      </Container>
    </div>
  )
}

export default AboutMe
